export default __webpack_public_path__ + "static/media/background.f3d3da61.jpg";